import React from "react";
import Banner from "../base/Banner";
import MetaHeader from "../base/MetaHeader";
import "../css/App.scss";
import JobListWithFilter from "./PositionList/JobListWithFilter";
import getCustomerData, {getPositionList} from "../../services/DataGetter";
import {setLanguage} from "../../enums/Languages";

export default class GateDashboard extends React.PureComponent
{
    constructor(props) {
        super(props);
        if (this.props.match.params['customerName'] === undefined) {
            this.props.history.push('/error/404');
        }
        if (window.location.href.indexOf('positions') === -1) {
            window.history.pushState(null, '',  window.location.href + ((window.location.href[window.location.href.length-1] !== '/' ) ? '/' : '') + 'positions');
        }
        if (this.props.match.params['source']) {
            sessionStorage.setItem('source', this.props.match.params['source']);
            window.history.pushState(null, '', window.location.href.split(this.props.match.params['source'])[0]);
        }

        this.state = {
            language: setLanguage(this.props.match.params['lang']),
            customerData: getCustomerData(this.props.match.params['customerName']),
        };
    }

    render() {
        const {language} = this.state;
        return (
            <>
				<MetaHeader
					description={window.Translator.getSlug('NGateMeta',this.state['language'])}/>
                <Banner
                    customerName={this.props.match.params['customerName']}
                    language={language}
                    customerData={this.state['customerData']}
                />
                <JobListWithFilter
                    customerName={this.props.match.params['customerName']}
                    language={language}
                    customerData={this.state['customerData']}
                    positionList={getPositionList(this.props.match.params['customerName'])}
                />
            </>
        );
    }
}
